export default "__VITE_ASSET__736a0a2e__"